import React, { useCallback } from 'react';

import { useAction } from 'core/store/store';

import { makeRegistrationSettingsDeliverySubmitAction } from 'state/registration/actions';

import { DeliveryForm, DeliveryFormData } from '../../../forms/DeliveryForm/DeliveryForm';

export interface DeliveryDialogProps {
    onClose: () => void;
}

export const DeliveryDialog = (props: DeliveryDialogProps) => {
    const action = useAction();
    // TODO: fetch initial form value here

    const handleSubmit = useCallback(
        (data: DeliveryFormData) => {
            action(makeRegistrationSettingsDeliverySubmitAction, data);
        },
        [action],
    );

    return <DeliveryForm onSubmit={handleSubmit} onClose={props.onClose} />;
};
